import { ComponentType } from "../../types/Questionnaire";

export const sequence = {
    sequence_empty_list: 'Aucun questionnaire n\'est disponible pour cette période.',
    sequence_list_summary_one: '{{count}} questionnaire à remplir',
    sequence_list_summary_other: '{{count}} questionnaires à remplir',
    sequence_empty_title: 'Tout est à jour',
    sequence_empty_text: 'Aucun questionnaire à remplir pour le moment.',
    sequence_next_label: 'Prochain :',
};